module.exports = __webpack_public_path__ + "img/13.a5048d22.jpg";